export default __webpack_public_path__ + "static/media/icon_search.0bd68311.svg";